/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    shape, string, func, bool, object,
} from 'prop-types';
import React, { useEffect } from 'react';
import mbpLogger from '@module-logger/mbp';
import { useQuery } from '@apollo/client';
import { connect, useDispatch } from 'react-redux';
import { getBestSellersId } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import findContent from '../../../../../gql/queries/findContent';
import ProductListingAdCategoryContainer from '../ProductListingAdCategoryContainer';

const GraphqlProductListAdCategoryContainer = ({
    brand,
    urlParams,
    bestSellersCategoryId,
    filterData,
    trackEvent,
    PLARecommendations,
    product,
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(trackEvent({
            eventName: 'feature_interaction',
            eventCategory: 'Product Page',
            eventAction: 'Customers Also Bought Impression',
            feature_detail: `${product?.partNumber} - ${brand?.id}`,
            feature_element: 'Customers Also Bought Control',
            feature_category: 'PLA',
        }));
    }, [product]);

    const GET_CATEGORY_ID_QUERY = findContent({
        brand: brand['domain-name'],
        contentType: 'pla_categories',
    });

    const getCategoryId = (categoryIds) => {
        const adCampaign = urlParams?.adcampaign?.toLowerCase() || '';
        // Set category by campaign ID
        if (categoryIds?.length && adCampaign?.length) {
            const categoryDetails = categoryIds.find((id) =>  adCampaign.includes(id.keyword));
            if (categoryDetails?.category_identifier) return categoryDetails.category_identifier;
        }

        // if categoryId does not exist, use best sellers from brand configuration
        if (bestSellersCategoryId?.length) {
            return bestSellersCategoryId;
        }

        // else use static id
        let categoryId = null;
        // Set default categories by brand (Fallback)
        if (brand.code === '18F') { categoryId = '18F-Best Selling Flowers-400215581'; }
        if (brand.code === 'BRY') { categoryId = 'BRY-Best Sellers-400214587'; }
        if (brand.code === 'FB') { categoryId = 'FB-Best Sellers-400181559'; }

        return categoryId;
    };

    const { data, error, loading } = useQuery(GET_CATEGORY_ID_QUERY);

    if (error) {
        mbpLogger.logError({
            jsError: error,
            message: `GraphqlProductListAdCategoryContainer error: ${error.message}`,
            component: 'GraphqlProductListAdCategoryContainer',
        });
    }

    if (loading) {
        return null;
    }

    // render ProductListingAdCategoryContainer even if no data is coming
    if (!error && !loading) {
        const identifierGroup = data?.findContent?.content?.entries?.[0]?.group;
        const categoryId = getCategoryId(identifierGroup);

        return (
            categoryId ? (
                <ProductListingAdCategoryContainer
                    categoryId={categoryId}
                    filterData={filterData}
                    trackEvent={trackEvent}
                    PLARecommendations={PLARecommendations}
                />
            ) : null
        );
    }
    return null;
};

GraphqlProductListAdCategoryContainer.propTypes = {
    brand: shape({
        'domain-name': string,
    }).isRequired,
    urlParams: shape({
        adCampaign: string,
    }).isRequired,
    bestSellersCategoryId: string,
    filterData: shape({
        highToLowBtn: string,
        lowToHighBtn: string,
    }),
    trackEvent: func.isRequired,
    PLARecommendations: bool,
    product: object,
};

GraphqlProductListAdCategoryContainer.defaultProps = {
    bestSellersCategoryId: '',
    filterData: {},
    PLARecommendations: false,
    product: {},
};

const mapStateToProps = (state) => ({
    bestSellersCategoryId: getBestSellersId(state),
});

export default connect(mapStateToProps)(GraphqlProductListAdCategoryContainer);
